export const DCNamespaces = {
  paddocks: 'paddock_production',
  grazing: 'farm_management_grazing',
  paddocksUsage: 'paddocks_usage',
}
